import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { registerDecoration } from 'core/forms';

import { createIconComponent } from 'uikit/icons';
import { Typo } from 'uikit/content';

import styles from '../styles/formDecorationWarning.module.scss';

const FormDecorationWarning = ({
  fieldId,
  schema,
}) => (
  <div
    className={classnames(styles.element, {
      [styles.isSecondaryVariant]: schema.variant === 'secondary',
    })}
    id={fieldId}
  >
    {createIconComponent({ icon: schema.icon, className: styles.icon, size: schema.iconSize })}
    <Typo className={styles.text} variant="b01">{schema.text}</Typo>
  </div>
);

FormDecorationWarning.propTypes = {
  fieldId: PropTypes.string.isRequired,
  schema: PropTypes.shape({}).isRequired,
};

registerDecoration('Warning', React.memo(FormDecorationWarning));

export default FormDecorationWarning;
